export function composeJotFormUrl(jotFormUrl: string, dealer: TrinityAPI.DealerType | null) {
  const firstName = dealer?.firstName ?? ''
  const lastName = dealer?.lastName ?? ''
  const companyName = dealer?.companyName ?? ''
  const email = dealer?.email ?? ''

  return `${jotFormUrl}?yourName[first]=${firstName}&yourName[last]=${lastName}&companyName=${companyName}&emailAddress=${email}`
}
